export default "__VITE_ASSET__CDTbi2qS__"